// Footer — notifications + logout + copyright.
import { useNavigate } from "@tanstack/react-router";
import { useAuthV2 as useAuth } from "@/lib/authv2/store";
import { EnableNotificationButton } from "../EnableNotificationButton";

export function SidebarFooter() {
  const clear = useAuth((s) => s.clear);
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Best-effort BE logout (revokes session). Even if it fails, clear local
    // state so the user lands on /login and can re-auth.
    try {
      const { logout: callLogout } = await import("@/lib/authv2/api");
      await callLogout();
    } catch {
      // ignore — local clear still happens below
    }
    clear();
    void navigate({ to: "/login" });
  };

  return (
    <div
      className="px-5 py-3"
      style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}
    >
      <div className="mb-2">
        <EnableNotificationButton />
      </div>
      <button
        type="button"
        onClick={() => void handleLogout()}
        className="mb-2 w-full rounded-md px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-black/10"
        style={{
          background: "rgba(0,0,0,0.12)",
          border: "1px solid rgba(255,255,255,0.15)",
        }}
      >
        Đăng Xuất
      </button>
      <div className="text-center text-[10px] text-white/95">
        GẠO NÂU PROFILE © 2026
      </div>
    </div>
  );
}
